export const getters = {
    getIsWidgetBusiness(state) {
        return !!state.isBusiness;
    },
    getIsWidgetVirtu(state) {
        return state.widgetId === 33;
    },
};
